import { PropsWithChildren } from 'react'
import { ErrorIcon } from 'components/patterns/icons'
import { FlexBox } from 'ui/primitives'
import { hspace } from './ErrorMessage.css'

interface Props {
	error: string
}

export const ErrorMessage = ({ error }: PropsWithChildren<Props>) => (
	<FlexBox display="flex" color="error.main" fontSize="xs">
		<ErrorIcon />
		<FlexBox display="inline-flex" className={hspace} />
		{error}
	</FlexBox>
)
